module.exports = __webpack_public_path__ + "static/media/post01.0b619474.jpg";